import React from 'react';
import { ArrowDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  const cycleSteps = [{
    title: 'Sueño malo',
    desc: 'No descansas profundamente'
  }, {
    title: 'Cortisol alto',
    desc: 'Tu cuerpo entra en alerta'
  }, {
    title: 'Resistencia a insulina',
    desc: 'Tu metabolismo se bloquea'
  }, {
    title: 'Barriga crece',
    desc: 'Acumulas grasa abdominal'
  }];
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-168">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <FadeIn data-id="element-171">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-172">
              No estás engordando porque comas más.
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-173">
            <p className="text-xl md:text-2xl text-terracotta font-medium" data-id="element-174">
              Estás acumulando grasa abdominal porque duermes mal.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} data-id="element-175">
          <div className="relative max-w-2xl mx-auto" data-id="element-176">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-terracotta/20 -translate-x-1/2 z-0" data-id="element-177"></div>

            <div className="space-y-6 relative z-10" data-id="element-178">
              {cycleSteps.map((step, index) => <div key={index} className="flex flex-col items-center" data-id="element-179">
                  <div className="bg-white w-full md:w-2/3 p-6 rounded-2xl shadow-card border border-cream-dark/50 text-center transform transition-transform hover:-translate-y-1" data-id="element-180">
                    <h4 className="text-xl font-serif font-bold text-charcoal mb-2" data-id="element-181">
                      {step.title}
                    </h4>
                    <p className="text-charcoal-light text-sm" data-id="element-182">{step.desc}</p>
                  </div>
                  {index < cycleSteps.length - 1 && <div className="my-4 text-terracotta/50" data-id="element-183">
                      <ArrowDown className="w-6 h-6" strokeWidth={2.5} data-id="element-184" />
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-16 text-center" data-id="element-185">
          <div className="inline-block bg-terracotta/10 px-8 py-4 rounded-xl border border-terracotta/20" data-id="element-186">
            <p className="text-lg md:text-xl font-bold text-terracotta-dark" data-id="element-187">
              Mientras sigas durmiendo mal… tu cuerpo seguirá acumulando grasa,
              aunque comas perfecto.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}